<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="
        position: absolute;
        z-index: 2;
        background-color: #ecececbd;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h3 style="text-shadow: 1px 1px 20px #9e9e9e" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h3>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom: 1.5em"
              small
              color="primary"
              @click="toggleBotStatus"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-container fluid>
      <div v-if="isTcpMainPage">
        <v-layout wrap>
          <v-flex xs12 sm6 class="py-3">
            <multiselect
              v-model="filterTcpPage"
              :options="tcpPageOptions"
              select-label
              selected-label
              placeholder="เลือกเพจ"
              label="page_name"
              style="margin-bottom: 4px"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-if="['ticket2', 'studio7'].includes(selectedBot.theme)"
        style="width: 40%"
        class="mb-3"
      >
        <multiselect
          v-model="selectedCom7page"
          :allow-empty="false"
          :show-labels="false"
          :searchable="false"
          label="name"
          :options="$store.state.com7pages"
          @input="updatekey++"
        >
        </multiselect>
        <!-- :options="[{ name: 'All', pageid: null }, ...$store.state.com7pages]" -->
      </div>
      <v-layout wrap>
        <v-flex
          v-if="!['105911105134578', '101931352240400'].includes(selectedBot.pageid)"
          xs12
          sm9
        >
          <DashboardSelectChannel v-model="filter" />
        </v-flex>
        <v-flex v-else xs12 sm9> </v-flex>
        <v-flex xs12 sm3 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              v-tooltip.top="'Unlock to PREMIUM plan'"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              color="grey"
              outline
              class="ma-0 mb-1"
              @click="exportDashboard"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter v-model="selectedDate"></date-filter>

      <v-layout wrap>
        <v-flex xs6>
          <h3 class="title">{{ $t('Metrics') }}</h3>
        </v-flex>
        <v-flex v-if="selectedBot && selectedBot.type === 'mtc'" xs6 class="pt-3">
          <multiselect
            v-model="filterUser"
            :options="filterUserOptions"
            label="label"
            value="value"
            :allow-empty="false"
            :show-labels="false"
          ></multiselect>
        </v-flex>
      </v-layout>
      <active-user-by-date
        :key="`active_user_by_date_${updatekey}`"
        :com7pageid="selectedCom7page.pageid"
        :loading="loadingActiveUserByDate"
        :selected-date="selectedDate"
        :filter="filter"
        :filter-user="filterUser"
        :filter-tcp-page="filterTcpPage"
        @onLoaded="onLoadingActiveUserByDate"
      ></active-user-by-date>
      <active-user-by-time
        :key="`active_user_by_time_${updatekey}`"
        :com7pageid="selectedCom7page.pageid"
        :loading="loadingActiveUserByTime"
        :selected-date="selectedDate"
        :filter="filter"
        :filter-user="filterUser"
        :filter-tcp-page="filterTcpPage"
        @onLoaded="onLoadingActiveUserByTime"
      ></active-user-by-time>
    </v-container>
  </div>
</template>

<script>
import { PAGE } from '@/constants/page.js'
import { mapGetters } from 'vuex'
import ActiveUserByDate from './ActiveUserByDate.vue'
import ActiveUserByTime from './ActiveUserByTime.vue'
import DateFilter from './../DateFilter'
import moment from 'moment'
import numeral from 'numeral'
import XLSX from 'xlsx'
import multiselect from 'vue-multiselect'
import DashboardSelectChannel from './../DashboardSelectChannel'

export default {
  components: {
    ActiveUserByDate,
    ActiveUserByTime,
    DateFilter,
    multiselect,
    DashboardSelectChannel
  },
  data: function () {
    return {
      updatekey: 0,
      selectedCom7page: {
        pageid: null,
        name: 'All'
      },
      loadingActiveUserByDate: true,
      loadingActiveUserByTime: true,
      filter: 'all',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      activeuserbydateSeries: [],
      activeuserbytimeSeries: [],
      filterUser: { label: 'All', value: 'all' },
      filterUserOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'Bot', value: 'bot' }
      ],
      filterTcpPage: ''
    }
  },
  computed: {
    loading: function () {
      return this.loadingActiveUserByDate && this.loadingActiveUserByTime
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    isTcpSubpage() {
      return PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
    }
  },
  mounted() {
    if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
      let com7page = this.$store.state.com7pages.find((f) => f.pageid == this.selectedBot.pageid)
      this.selectedCom7page.name = com7page.name
    }

    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }
  },
  methods: {
    onLoadingActiveUserByDate: function (value) {
      this.loadingActiveUserByDate = value.loading
      if (value.data) {
        this.activeuserbydateSeries = value.data
      }
    },
    onLoadingActiveUserByTime: function (value) {
      this.loadingActiveUserByTime = value.loading
      if (value.data) {
        this.activeuserbytimeSeries = value.data
      }
    },
    exportDashboard: function () {
      let vm = this
      if (vm.loading) {
        return false
      }
      let json = []
      json.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate.end).format('DD/MM/YYYY')
      ])
      if (vm.isTcpMainPage || vm.isTcpSubpage) {
        json.push(['Page', vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.selectedBot.pagename])
      }

      json.push([])
      json.push([this.$t('Active Users by Date')])
      json.push([
        this.$t('Date'),
        vm.activeuserbydateSeries[0].name,
        vm.activeuserbydateSeries[1].name,
        vm.activeuserbydateSeries[2].name
      ])

      vm.activeuserbydateSeries[0].data.forEach((seriesData, index) => {
        json.push([
          moment(seriesData[0]).format('DD/MM/YYYY'),
          numeral(vm.activeuserbydateSeries[0].data[index][1]).format('0,0'),
          numeral(vm.activeuserbydateSeries[1].data[index][1]).format('0,0'),
          numeral(vm.activeuserbydateSeries[2].data[index][1]).format('0,0')
        ])
      })

      let json1 = []
      json1.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json1.push([])
      json1.push([this.$t('Messages by Time')])

      vm.activeuserbytimeSeries[0].data.forEach((seriesData, index) => {
        json1.push([index + ':00', numeral(seriesData).format('0,0')])
      })

      // console.log("json1: ",json1);
      const wb = XLSX.utils.book_new()
      const dataWS1 = XLSX.utils.json_to_sheet(json)
      const dataWS2 = XLSX.utils.json_to_sheet(json1)
      XLSX.utils.book_append_sheet(wb, dataWS1, 'Active Users by Date')
      XLSX.utils.book_append_sheet(wb, dataWS2, 'Messages by Time')
      XLSX.writeFile(wb, 'zwizdata-matrics.xlsx')
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/active-user/ActiveUserGraph.vue